/* RESPONSIBLE TEAM: team-ai-insights */
import { AI_INSIGHTS_ID } from 'embercom/lib/billing';
import type Product from 'embercom/models/product';

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function isRecentAiInsightsPurchase(products: Product[]): boolean {
  let aiInsightsProduct = products.find((product) => product.id === AI_INSIGHTS_ID);
  if (!aiInsightsProduct) {
    return false;
  }

  let now = Date.now();

  if (aiInsightsProduct.activeTrialStartedAt) {
    let trialStartedAt = new Date(aiInsightsProduct.activeTrialStartedAt).getTime();
    if (now - trialStartedAt < TWENTY_FOUR_HOURS_MS) {
      return true;
    }
  }

  let activatedAt = aiInsightsProduct.activePlan?.activatedAt;
  if (activatedAt) {
    let activatedAtMs = new Date(activatedAt).getTime();
    if (now - activatedAtMs < TWENTY_FOUR_HOURS_MS) {
      return true;
    }
  }

  return false;
}
